module.exports = __webpack_public_path__ + "increase2.png?316fac50329a0e05597f5d9c8227963e";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/increase2.png
// module id = 344
// module chunks = 0